import { ImportIcon } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; 
import { useTheme  } from '../context/ThemeContext';
import './Chat/answer.css'

const NewTableComponent = ({ title, data, isShown, updateShownState, isAnyTableShown }) => {
  const tableRef = useRef();
  const [meanScore, setMeanScore] = useState(0);
  const { isDarkMode, themeClass, toggleTheme } = useTheme();

  function parseContentToHtml(content) {
    if (!content) return '';
    
    content = content.replace(/\.\s*\*\s*/g, '. ');
    
    // Unir solo líneas que son continuación (no empiezan con Artículo, número+punto, o *)
    content = content.replace(/\s*\n(?!Art[ií]culo\s+\d)(?!\d+\.)(?!\*)/g, ' ');
    
    const lines = content.split(/\r?\n|\r/);
    
    const processedLines = lines.map(line => {
      line = line.trim();
      if (!line) return '<div class="article-spacing"></div>';
      
      const articleMatch = line.match(/^(Art[ií]culo\s+\d+[a-zA-Z]?\.\s*)(.*)$/i);
      
      if (articleMatch) {
        const title = articleMatch[1].trim();
        const restOfContent = articleMatch[2].trim();
        
        // Detectar si lo que sigue es el nombre (todo mayúsculas terminado en punto)
        const nameMatch = restOfContent.match(/^([A-ZÁÉÍÓÚÜÑ\s]+\.)(.*)$/);
        
        if (nameMatch) {
          const articleName = nameMatch[1].trim();
          const bodyContent = nameMatch[2].trim();
          
          if (bodyContent) {
            return `<h4 class="article-title">${title} ${articleName}</h4><p class="article-text">${bodyContent}</p>`;
          } else {
            return `<h4 class="article-title">${title} ${articleName}</h4>`;
          }
        }
        
        if (restOfContent) {
          return `<h4 class="article-title">${title}</h4><p class="article-text">${restOfContent}</p>`;
        }
        
        return `<h4 class="article-title">${title}</h4>`;
      }
      
      return `<p class="article-text">${line}</p>`;
    });
    
    return processedLines.join('');
  }
  useEffect(() => {
    if (isShown) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [isShown]);

  useEffect(() => {
    if (data && data.length > 0) {
      const scoresToConsider = data.slice(0, 1);
      const totalScore = scoresToConsider.reduce((sum, item) => sum + parseFloat(item.score), 0);
      const divisor = scoresToConsider.length;

      const mean = totalScore / divisor;
      setMeanScore(mean.toFixed(2));
    }
  }, [data]);   

  const handleToggle = () => {
    updateShownState(!isShown);
  };

  return (
    data && data.length > 0 &&
    <>
      <h2 onClick={handleToggle} style={{ width: '100%', marginBottom: '10px' }}>
        <button 
          className={`content-button status-button tableBut ${isShown ? 'closed' : 'open'} ${themeClass}`}>
          <span className={`tablebutporcenta ${themeClass}`}>
            {title}
          </span>
          <span className={`  ${themeClass}`} >
            {meanScore}% {isShown ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        </button>
      </h2>
      {isShown && (
        <div ref={tableRef} className="table-wrapper">
          <table>
            <thead className={`contentOfButton  ${themeClass}`} >
              <tr>
                <th>Content</th>
              </tr>
            </thead>
            <tbody className={`contentOfButton2  ${themeClass}`}>
              {data.map((item, index) => (
                <tr key={index}>
                  <td dangerouslySetInnerHTML={{ __html: parseContentToHtml(item.content) }} />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default NewTableComponent;